import { render, staticRenderFns } from "./sanity-content.vue?vue&type=template&id=502626c2"
import script from "./sanity-content.vue?vue&type=script&lang=js"
export * from "./sanity-content.vue?vue&type=script&lang=js"
import style0 from "./sanity-content.vue?vue&type=style&index=0&id=502626c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports